import { useState } from "react";
import { useAuth } from "../../lib/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function LoginForm() {
  const [form, setForm] = useState({
    email: "",
    password: ""
  })
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");


    try {
      const response = await fetch("https://api.explorelrt.com/signin", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(form).toString(),
      });

      const data = await response.json();

      if (!response.ok) {
        setStatus(data.error);
        return;
      }

      if (data.success === true) {
        setStatus(data.message);
        login({ name: data.name, email: data.email });
        navigate("/");
      }


    
    } catch (e) {
      console.error("Error submitting feedback:", e);
    } finally {
      setLoading(false);
    }

  };

  return (



      <form onSubmit={handleLogin} className="loginContainer">

        <div className="loginSection">
        <h1>Welcome Back</h1>
      </div>



        <div className="loginSection">
          <label className="loginLabel" htmlFor="email">
            Email:
          </label>
          <input
            id="email"
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="you@example.com"
            autoComplete="email"
            required
          />

        </div>


        <div className="loginSection">
          <label className="loginLabel" htmlFor="password">
            Password:
          </label>
          <input
            id="password"
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />

        </div>

        <div className="loginSection">
          {status && <p style={{ color: "gray" }}>{status}</p>}

          <button type="submit" className="loginButton" disabled={loading}>
            {loading ? "Logging In..." : "Login"}
          </button>
        </div>
      </form>


  );
}


